import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IMobileBranding } from '../interfaces/mobile-branding';

@Injectable({ providedIn: 'root' })
export class MobileBrandingService {
  constructor(private http: HttpClient) {}

  save(data: IMobileBranding): Promise<any> {
    console.log(data);
    return this.http.post('api/supplier/savesupplierdetails', data).toPromise();
  }

  getsupplierdetails(): Promise<IMobileBranding> {
    return this.http.get<IMobileBranding>('api/supplier/getsupplierdetails').toPromise().catch();
  }
}
